export const BEST_WEB_GAMES_DOMAIN = 'best-web-games.net'

export function isBestWebGamesHost(host: string | undefined) {
    const normalizedHost = host?.split(':')[0]?.toLowerCase()

    return normalizedHost === BEST_WEB_GAMES_DOMAIN || !!normalizedHost?.endsWith(`.${BEST_WEB_GAMES_DOMAIN}`)
}
